import { render } from "./SampleFields.vue?vue&type=template&id=227db51b&scoped=true"
import script from "./SampleFields.vue?vue&type=script&lang=js"
export * from "./SampleFields.vue?vue&type=script&lang=js"

import "./SampleFields.vue?vue&type=style&index=0&id=227db51b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227db51b"]])

export default __exports__